import CardConvidadoHistory from './CardConvidadoHistory'

export default CardConvidadoHistory